<template>
  <section v-if="loading">
    <loading />
  </section>
  <section class="termo-aceite" v-else>
    <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
    <Aceite
      :voltar="voltar"
      :action-voltar="true"
      :action-aceite="true"
      @click="salvarAceite"
      @fechar="fechar"
      :file="file"
      :aceite="aceite"
      :loading="loadingSave"
      :strLoading="'Aguarde, salvando termo'"
    />
    <div class="py-5"></div>
  </section>
</template>
<script>
import Aceite from "@/components/aceite/Aceite.vue";
export default {
  name: "TermoAceite",
  components: {
    Aceite,
  },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente/produtos",
        },
        {
          nome: "Termo de Aceite",
          id: "termoAceite",
          produto: "CDL Varejo Inteligente",
        },
      ],
      voltar: true,
      loading: false,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Estou de acordo com o termo acima.",
      file: null,
      tipoReserva: null,
      loadingSave: false,
      eventoId: null,
      rotaVotar: null,
      paramsRota: {},
    };
  },
  methods: {
    async salvarAceite(payload) {
      this.loadingSave = true;
      this.$emit("click", {
        checkAceite: payload.checkAceite,
      });

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      const dadosTermo = {
        dtVersao: date,
        dtAceite: date,
        ipOrigem: sessionStorage.ip,
        browserData: navigator.appVersion,
        eventoId: this.eventoId,
      };

      await this.$http
        .post("/api/Agenda/AceitarTermoVarejoInteligente", dadosTermo)
        .then((response) => {
          if (response.status === 200) {
            if (
              this.tipoReserva === "estacao-trabalho" ||
              this.tipoReserva === "escritorio-virtual"
            ) {
              this.pagamentoBoleto();
            } else {
              this.$router.push({ name: "pagamentoVarejo" });
            }
          }
        })
        .catch((error) => {
          if (error.statusCode === 401) {
            this.$router.push({ name: "login" });
          }
          console.error(error);
          this.$toast.open({
            message: "Erro ao assinar o termo, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
    pagamentoBoleto() {
      // Efetuar pagamento facoob
      this.$http
        .post(
          `/api/Agenda/PagamentoBoletoMensalVarejoInteligente?eventoid=${this.eventoId}`
        )
        .then((response) => {
          if (response.data.sucesso) {
            sessionStorage.removeItem("reserva");
            this.$toast.open({
              message:
                "Valor registrado no boleto mensal! Redirecionando para o painel de reservas...",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push({
                name: "varejo",
              });
            }, 2000);
          }
        })
        .catch((error) => {
          if (error.statusCode === 401) {
            this.$router.push({ name: "login" });
          }
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
        });
    },
    fechar() {
      this.cancelarReserva();
      this.$router.push({ name: this.rotaVotar, params: this.paramsRota });
    },
    cancelarReserva() {
      const session = JSON.parse(sessionStorage.getItem("reserva"));

      if (session.reserva) {
        const cancelarReserva = {
          agendaId: session.simularDados.agendaId,
          eventoId: session.reserva.simulado.eventoId,
        };

        this.$http
          .post("/api/Agenda/CancelarReserva", cancelarReserva)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    const session = JSON.parse(sessionStorage.getItem("reserva"));
    this.loading = true;
    this.tipoReserva = session.tipoReserva;

    // Monta a rota para o botão voltar
    if (session.tipoReserva === "estacao-trabalho") {
      this.rotaVotar = "formularioEstacaoTrabalho";
    } else if (session.tipoReserva === "escritorio-virtual") {
      this.rotaVotar = "formularioEstacaoTrabalho";
      this.paramsRota = {
        idAgenda: session.simularDados.agendaId,
        tipoReserva: session.tipoReserva,
      };
    } else {
      this.rotaVotar = "agenda";
    }

    await this.cancelarReserva();

    this.$http
      .post("/api/Agenda/SimularReserva", session.simularDados)
      .then((response) => {
        session.reserva = response.data;
        sessionStorage.setItem("reserva", JSON.stringify(session));
        this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
        this.eventoId = response.data.simulado.eventoId;
        this.loading = false;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        if (error.response.status === 400) {
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "warning",
          });
          this.$router.push({ name: "agenda" });
        }
        this.loading = false;
      });
  },
};
</script>
